module.exports = __webpack_public_path__ + "img/cafes-icon.80e35d22.svg";